"use client";

import { ScrollShadow as HeroScrollShadow } from "@heroui/react";
import { cn } from "../../lib/utils";

export const ScrollShadow = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroScrollShadow>) => {
  return <HeroScrollShadow className={cn(className)} {...props} />;
};
